import { ChildId, GuardianId } from 'types';

export const CHILDREN = '/api/v1/children/for-parent';
export const CHILD_DETAILS = (childId: ChildId) => `${CHILDREN}/${childId}`;
export const CHILD_GUARDIAN_BASE = (childId: ChildId) => `${CHILD_DETAILS(childId)}/guardians`;
export const CHILD_GUARDIAN = (childId: ChildId, guardianId: GuardianId) =>
    `${CHILD_GUARDIAN_BASE(childId)}/${guardianId}`;
export const CHILD_PROFILE_PHOTO = (childId: ChildId) => `${CHILD_DETAILS(childId)}/profile-photo`;
export const CHILD_PARENT_PROFILE = (childId: ChildId) => `${CHILD_DETAILS(childId)}/parents`;
